export default __webpack_public_path__ + "static/media/outside.f1db05ce.png";